import { ReactComponent } from "./memo-drop-off-line.svg";

interface Props {
  fill?: string;
  width?: string;
  height?: string;
}

const MemoDropOffLineIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default MemoDropOffLineIcon;
